




import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Reject080Config extends Vue {}
